export const UserRoleDropdownText: string = "ApplicationUserRole";
export const BillingIntervalDropdownText: string = "BillingIntervalOption";
export const actionValidationDurationUnitText: string = "LicenseActionValidationDurationUnit";

export const DefaultUserRole: number[] = [1];
export const DefaultBillingIntervalValue: number = 0;
export const DefaultActionValidationDurationUnitValue: number = 1;